<app-card
  #cardComponent
  [title]="'PEOPLE_FORM.FORM.EMAIL.TITLE' | translate"
  [index]="index()"
  (deleteCard)="remove.emit()"
  [totalItems]="totalItems()"
  [disabled]="disabled()"
>
  <app-email-form
    [control]="control()"
    [disabled]="disabled()";
  />
</app-card>
